import React from 'react'

const InterventionsUsed = ({ interventionsUsedData, handleInterventionsUsed }) => {
  return (
        <div className="observation-content"> 
            <div className="d-flex justify-content-between">
                <div className="">
                <p className="heading mb-1">Cognitive/Behavioral:</p>
                <div className="d-flex flex-column gap-2">
                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="CognitiveChallenging"
                            id="CognitiveChallenging"
                            checked={interventionsUsedData?.CognitiveChallenging === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Cognitive Challenging</p>
                    </label>

                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="CognitiveReframing"
                            id="CognitiveReframing"
                            checked={interventionsUsedData?.CognitiveReframing === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Cognitive Reframing</p>
                    </label>

                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="CognitiveRefocusing"
                            id="CognitiveRefocusing"
                            checked={interventionsUsedData?.CognitiveRefocusing === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Cognitive Refocusing</p>
                    </label>

                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="CommunicationSkills"
                            id="CommunicationSkills"
                            checked={interventionsUsedData?.CommunicationSkills === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Communication Skills</p>
                    </label>

                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="DBT"
                            id="DBT"
                            checked={interventionsUsedData?.DBT === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">DBT</p>
                    </label>

                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="PsychoEducation"
                            id="PsychoEducation"
                            checked={interventionsUsedData?.PsychoEducation === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Psycho Education</p>
                    </label>

                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="StructuredProblemSolving"
                            id="StructuredProblemSolving"
                            checked={interventionsUsedData?.StructuredProblemSolving === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Structured Problem Solving</p>
                    </label>
                </div>
                </div>

                <div className="">
                <p className="heading mb-1">Emotional/Insight Based:</p>
                <div className="d-flex flex-column gap-2">
                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="CrisisManagement"
                            id="CrisisManagement"
                            checked={interventionsUsedData?.CrisisManagement === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Crisis Management</p>
                    </label>
                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="ExplorationOfEmotions"
                            id="ExplorationOfEmotions"
                            checked={interventionsUsedData?.ExplorationOfEmotions === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Exploration of Emotions</p>
                    </label>
                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="ExplorationOfRelationshipPatterns"
                            id="ExplorationOfRelationshipPatterns"
                            checked={interventionsUsedData?.ExplorationOfRelationshipPatterns === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Exploration of Relationship Patterns</p>
                    </label>
                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                        
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="ExplorationOfCopingPatterns"
                            id="ExplorationOfCopingPatterns"
                            checked={interventionsUsedData?.ExplorationOfCopingPatterns === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Exploration of Coping Patterns</p>
                    </label>
                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                        
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="GuidedImagery"
                            id="GuidedImagery"
                            checked={interventionsUsedData?.GuidedImagery === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Guided Imagery</p>
                    </label>
                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                        
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="SymptomManagement"
                            id="SymptomManagement"
                            checked={interventionsUsedData?.SymptomManagement === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Symptom Management</p>
                    </label>

                </div>
                </div>

                <div className="">
                <p className="heading mb-1">Supportive/Skill-Building:</p>

                <div className="d-flex flex-column gap-2">
                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                        
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="EmotionalRegulationSkills"
                            id="EmotionalRegulationSkills"
                            checked={interventionsUsedData?.EmotionalRegulationSkills === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Emotional Regulation Skills</p>
                    </label>

                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                        
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="InteractiveFeedback"
                            id="InteractiveFeedback"
                            checked={interventionsUsedData?.InteractiveFeedback === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Interactive Feedback</p>
                    </label>

                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                        
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="InterpersonalResolutions"
                            id="InterpersonalResolutions"
                            checked={interventionsUsedData?.InterpersonalResolutions === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Interpersonal Resolutions</p>
                    </label>

                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                        
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="MindfulnessTraining"
                            id="MindfulnessTraining"
                            checked={interventionsUsedData?.MindfulnessTraining === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Mindfulness Training</p>
                    </label>

                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                        
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="RelaxationDeepBreathing"
                            id="RelaxationDeepBreathing"
                            checked={interventionsUsedData?.RelaxationDeepBreathing === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Relaxation/Deep Breathing</p>
                    </label>

                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                        
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="SupportiveReflection"
                            id="SupportiveReflection"
                            checked={interventionsUsedData?.SupportiveReflection === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Supportive Reflection</p>
                    </label>
                </div>
                </div>

                <div className="">
                <p className="heading mb-1">Behavioral/Plan-Focused:</p>

                <div className="d-flex flex-column gap-2">
                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="ComplianceIssues"
                            id="ComplianceIssues"
                            checked={interventionsUsedData?.ComplianceIssues === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Compliance Issues</p>
                    </label>

                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="PreventativeServices"
                            id="PreventativeServices"
                            checked={interventionsUsedData?.PreventativeServices === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Preventative Services</p>
                    </label>

                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="ReviewOfPlan"
                            id="ReviewOfPlan"
                            checked={interventionsUsedData?.ReviewOfPlan === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Review of Plan</p>
                    </label>

                    <label className="d-flex align-items-center gap-6 user-select-none">
                    <div className="custom_check_box d-flex">
                        <input
                        
                            type="checkbox"
                            className="form-check-input m-0 p-0"
                            name="RolePlayBehavioralRehearsal"
                            id="RolePlayBehavioralRehearsal"
                            checked={interventionsUsedData?.RolePlayBehavioralRehearsal === "true"}
                            onChange={handleInterventionsUsed}
                        />
                    </div>
                    <p className="text fs-13">Role-Play/Behavioral Rehearsal</p>
                    </label>

                </div>
                </div>
            </div>
        </div>
  )
}

export default InterventionsUsed